module.exports = __webpack_public_path__ + "static/media/svglogo.2313ffed.svg";